import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-air',
  templateUrl: './button-air.component.html',
})
export class ButtonAirComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
